import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import Item from './Item'
import BioLightbox from './BioLightbox'
import Button from 'components/ui/Button'
import { BodyCopy } from 'components/ui/Typography'
import { Section, Container } from 'components/layout'

import s from './TeamSection.module.scss'
const cn = classNames.bind(s)

const _ = {
  shapes: ['circle', 'rectangle'],
}

const TeamSection = ({ data, cta }) => {
  const [activeShapeIndex, setActiveShapeIndex] = useState(0)
  const [selectedMember, setSelectedMember] = useState(null)

  const updateShapeSequence = () => setActiveShapeIndex((index) => (index + 1) % _.shapes.length)
  const closeLightbox = useCallback(() => setSelectedMember(null), [])

  return (
    <Section>
      <Container>
        <div className={cn('wrapper')} onMouseLeave={() => setActiveShapeIndex(0)}>
          {data.map((item, i) => (
            <Item
              key={i}
              image={item.imageSharp}
              name={item.name ? item.name[0].text : ''}
              position={item.position ? item.position[0].text : ''}
              brief={item?.brief || ''}
              column1={item?.column_1}
              column2={item?.column_2}
              callback={updateShapeSequence}
              shape={_.shapes[activeShapeIndex]}
              onReadMore={setSelectedMember}
            />
          ))}
          {cta && (
            <div className={cn('item', 'cta')}>
              <BodyCopy className={cn('link')}>
                <Button to={cta.team_link.url}>{cta.team_cta}</Button>
              </BodyCopy>
            </div>
          )}
        </div>
      </Container>
      <BioLightbox member={selectedMember} onClose={closeLightbox} />
    </Section>
  )
}

TeamSection.propTypes = {
  data: PropTypes.array,
  cta: PropTypes.object,
}

export default TeamSection
